import { animate, style, transition, trigger } from "@angular/animations";
import { CommonModule } from "@angular/common";
import { Component, HostListener, Input } from "@angular/core";
import { Survey, SurveyQuestionType } from "../survey";
import { SurveyQuestionContainerComponent } from "../survey-question-container/survey-question-container.component";

@Component({
    selector: "adapt-survey-container",
    standalone: true,
    imports: [SurveyQuestionContainerComponent, CommonModule],
    templateUrl: "./survey-container.component.html",
    animations: [
        trigger("simpleFadeAnimation", [
            transition("*=>*", [
                style({ opacity: 0 }),
                style({ "margin-top": -100 }),
                animate(250, style({ "margin-top": 0 })),
                animate(250, style({ opacity: 1 })),
            ]),
        ]),
    ],
})
export class SurveyContainerComponent {
    public questionIndex = 0;
    public finished = false;

    @Input() public survey!: Survey;

    @HostListener("document:keydown", ["$event"])
    public onKeydownHandler(event: KeyboardEvent) {
        if (event.key == "Enter") {
            this.handleContinueButton();
        } else if ((event.key == "ArrowLeft") || (event.key == "ArrowUp")) {
            this.handlePrevButton();
        } else if ((event.key == "ArrowRight") || (event.key == "ArrowDown")) {
            this.handleNextButton();
        }
    }

    public handleContinueButton() {
        if (this.isLastQuestion) {
            setTimeout(() => this.finished = true,
                300);

            setTimeout(
                () => window.open(`https://theadaptway.com/north-star-result?current=${this.survey.primaryCurrentState[0]}&future=${this.survey.primaryFutureState[0]}`, "_top"),
                2000);
        } else {
            this.questionIndex++;
        }
    }

    public get buttonText() {
        const questionType = this.survey.questions[this.questionIndex].type;
        switch (questionType) {
            case SurveyQuestionType.options:
                return this.isLastQuestion
                    ? "Submit"
                    : "Next";

            case SurveyQuestionType.intro:
                return "Start questionnaire";

            case SurveyQuestionType.statement:
                return "Continue";

            default:
                throw new Error("Unknown question type");
        }
    }

    public get questionButtonText() {
        if (this.survey.questions[this.questionIndex].type === SurveyQuestionType.options) {
            return this.isLastQuestion
                ? "Submit"
                : "Next";
        }

        return "Continue";
    }

    public get rankedWants() {
        return this.survey.rankedWants;
    }

    public get primaryCurrentState() {
        return this.survey.primaryCurrentState;
    }

    public get secondaryCurrentState() {
        return this.survey.secondaryCurrentState;
    }

    public get primaryFutureState() {
        return this.survey.primaryFutureState;
    }

    public get secondaryFutureState() {
        return this.survey.secondaryFutureState;
    }

    public get isLastQuestion() {
        return this.questionIndex >= this.survey.questions.length - 1;
    }

    public get isFirstQuestion() {
        return this.questionIndex == 0;
    }

    public handleNextButton() {
        if (!this.isLastQuestion) {
            this.questionIndex++;
        }
    }

    public handlePrevButton() {
        if (!this.isFirstQuestion) {
            this.questionIndex--;
        }
    }
}
